/* eslint-disable */
import React from 'react'
import jMoment from 'moment-jalaali'
import InputMask from 'react-input-mask'
import moment from 'moment'

class SinglePicker extends React.Component {
  constructor(props) {
    super(props)

    if (this.props.defaulValue) {
      this.state = {
        value: this.convertDigit(jMoment().format('jYYYY/jMM/jDD'))
      }
      this.props.changeDate(this.epoch(this.state.value))
    } else {
      this.state = {
        value: ''
      }
    }

    this.fromDate = React.createRef()
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.defaulValue !== this.props.defaulValue) {
      // this.setState({
      //     fromValue:''
      // })
      // this.props.onChangeFromDate('')
      // this.props.onChangeToDate('')
    } else {
    }
  }

  epoch = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)

      let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
      let from = miladiDate + ' ' + '00:00'
      let fromEpoch = moment.utc(from).valueOf()
      if (n >= 0) {
        return fromEpoch - 3.5 * 3600 * 1000
      } else {
        return fromEpoch - 3.5 * 3600 * 1000
      }
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  onChange = (event) => {
    this.setState({
      value: event.target.value
    })

    if (event.target.value == '') {
      this.props.changeDate('')
    } else {
      this.props.changeDate(this.epoch(event.target.value))
    }
    // if(event.target.value.match(/^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/)){
    //
    //     this.fromDate.current.focus()
    //     let {fromId,toId}=this.props;
    //     document.getElementById(fromId).focus();
    //     document.getElementById(toId).focus();
    //     this.props.onChangeToDate(this.epochTo((event.target.value)))
    //     this.setState({
    //         toValue: event.target.value
    //     });
    // }
  }

  beforeMaskedValueChangeFrom = (newState, oldState, userInput) => {
    var {value} = newState
    var selection = newState.selection
    var cursorPosition = selection ? selection.start : null

    // keep minus if entered by user
    if (value.endsWith('-') && userInput !== '-' && !this.state.value.endsWith('-')) {
      if (cursorPosition === value.length) {
        cursorPosition--
        selection = {start: cursorPosition, end: cursorPosition}
      }
      value = value.slice(0, -1)
    }

    return {
      value,
      selection
    }
  }

  clearDate = () => {
    this.setState({
      value: ''
    })
    this.props.changeDate('')
    let {id} = this.props
    document.getElementById(id).focus()
  }

  render() {
    return (
      <div className="relativeComponent">
        <label className="labelComponent">
          {this.props.label}{' '}
          <span style={this.props.force ? {visibility: 'visible'} : {visibility: 'hidden'}} className="requireFiled">
            *
          </span>
        </label>
        <InputMask
          disabled={this.props.disabled ? true : false}
          autocomplete="off"
          placeholder="yyyy/mm/dd"
          id={this.props.id}
          className="form-control"
          mask="9999/99/99"
          maskChar={null}
          value={this.state.value}
          onChange={this.onChange}
          beforeMaskedValueChange={this.beforeMaskedValueChangeFrom}
        />
        {/*{!this.props.disabled && <img onClick={()=>this.clearDate()}*/}
        {/*src={require('../../image/close.svg')} style={{width:20,position:'absolute',top:52,left:15,cursor:'pointer'}}/>}*/}
      </div>
    )
  }
}
export default SinglePicker
